// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"19288":"39477768e0","66586":"bb45a9ac63","67064":"fb5940289a","94965":"e6aaf522e5"}[chunkId] + ".css";
};